
import {
  Palette,
  Ruler,
  ShieldCheck,
  Building2,
} from 'lucide-react';

import CategoryTemplate from '../components/CategoryTemplate';
import { getRelated } from '../data/serviceCatalog';

const Signage = () => {
  const trustPoints = [
    { Icon: Palette, label: 'デザインから製作まで' },
    { Icon: Ruler, label: '現場合わせのサイズ設計' },
    { Icon: ShieldCheck, label: '屋外設置に耐える構造' },
    { Icon: Building2, label: '屋外広告物 許可申請対応' },
  ];

  const types = [
    {
      title: '壁面看板',
      desc: '建物の壁面に取り付ける平面看板。店舗・オフィスの顔となる要素です。',
    },
    {
      title: '自立看板',
      desc: '独立して設置する看板。駐車場・敷地入口・案内表示などに活用します。',
    },
    {
      title: '箱文字・チャンネル文字',
      desc: '立体感のある文字看板。箱文字、金属文字、LEDチャンネル文字、LEDネオンチャンネルなどに対応します。',
      image: '/images/channel-letters/channel-hero.png',
      to: '/products/signage/channel-letters',
    },
    {
      title: '案内サイン',
      desc: '施設内の案内・誘導・方向指示に使うサイン。',
    },
    {
      title: '店舗サイン',
      desc: '店舗ファサード・エントランス・軒下の看板類。',
    },
    {
      title: '屋外サイン',
      desc: '屋外設置に対応した耐候性看板。素材・構造を現場に合わせて選定。',
    },
  ];

  const process = [
    {
      title: 'ヒアリング',
      desc: '設置場所・希望のデザイン・予算・納期などをお伺いします。',
    },
    {
      title: '現地調査',
      desc: '取付面のサイズ・環境・建物構造・電源経路などを確認します。',
    },
    {
      title: 'デザイン・見積提出',
      desc: 'デザイン案とお見積りをご提出し、内容の合意を得ます。',
    },
    {
      title: '製作・施工',
      desc: '製作から現場での施工まで責任をもって対応いたします。',
    },
  ];

  return (
    <CategoryTemplate
      id="signage"
      eyebrow="SIGN DESIGN"
      name="看板・サイン"
      description="店舗看板、施設サイン、案内表示など、設置場所や目的に合わせた看板・サインをご提案いたします。デザインから製作、施工までを一貫して対応します。"
      tags={[
        '壁面看板',
        '自立看板',
        '箱文字',
        '案内サイン',
        '許可申請対応',
      ]}
      heroImage="/images/services/signage.png"
      trustPoints={trustPoints}
      types={types}
      processSteps={process}
      worksCategory="看板・サイン"
      relatedServices={getRelated([
        'led-lighting',
        'electric-board',
        'custom-metal',
      ])}
    />
  );
};

export default Signage;
